// extracted by mini-css-extract-plugin
export var buttons = "X_bC";
export var current = "X_d6";
export var image = "X_k";
export var marker = "X_d5";
export var markers = "X_d4";
export var p = "X_dK";
export var promotions = "X_d7";
export var section = "X_j";
export var textContainer = "X_b6";